import type { ISerialize } from '@/objects/ISerialize';
import type { SearchType } from './../enums/SearchType';

export class ParticipantSearchRequest implements ISerialize {
    public EventID: number | null;

    public IncludeMerged: boolean;

    public Maxitems: number;

    public OnlyUsedByMyOrganizer: boolean;

    public OnlyWithFISCode: boolean;

    public OnlyWithNCFLicense: boolean;

    public Query: string | null;

    public SearchType: SearchType;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        EventID?: number | null;
        IncludeMerged?: boolean;
        Maxitems?: number;
        OnlyUsedByMyOrganizer?: boolean;
        OnlyWithFISCode?: boolean;
        OnlyWithNCFLicense?: boolean;
        Query?: string | null;
        SearchType?: SearchType;
    }) {
        this.EventID = values.EventID ?? null;

        this.IncludeMerged = values.IncludeMerged ?? false;

        this.Maxitems = values.Maxitems ?? 0;

        this.OnlyUsedByMyOrganizer = values.OnlyUsedByMyOrganizer ?? false;

        this.OnlyWithFISCode = values.OnlyWithFISCode ?? false;

        this.OnlyWithNCFLicense = values.OnlyWithNCFLicense ?? false;

        this.Query = values.Query ?? null;

        this.SearchType = values.SearchType ?? 'StartsWith';
    }

    public serialize(): string {
        return (
            '{' +
            `"EventID": ${JSON.stringify(this.EventID)}` +
            ',' +
            `"IncludeMerged": ${JSON.stringify(this.IncludeMerged)}` +
            ',' +
            `"Maxitems": ${JSON.stringify(this.Maxitems)}` +
            ',' +
            `"OnlyUsedByMyOrganizer": ${JSON.stringify(this.OnlyUsedByMyOrganizer)}` +
            ',' +
            `"OnlyWithFISCode": ${JSON.stringify(this.OnlyWithFISCode)}` +
            ',' +
            `"OnlyWithNCFLicense": ${JSON.stringify(this.OnlyWithNCFLicense)}` +
            ',' +
            `"Query": ${JSON.stringify(this.Query)}` +
            ',' +
            `"SearchType": ${this.SearchType == 'StartsWith' ? 0 : this.SearchType == 'EndsWith' ? 1 : this.SearchType == 'ExactWord' ? 2 : this.SearchType == 'Contains' ? 3 : this.SearchType == 'ContainsAll' ? 4 : 0}` +
            '}'
        );
    }

    /**
     * Creates an instance of ParticipantSearchRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        EventID?: number | null;
        IncludeMerged?: boolean;
        Maxitems?: number;
        OnlyUsedByMyOrganizer?: boolean;
        OnlyWithFISCode?: boolean;
        OnlyWithNCFLicense?: boolean;
        Query?: string | null;
        SearchType?: SearchType;
    }): ParticipantSearchRequest {
        return new ParticipantSearchRequest(values);
    }

    public static _FromServerJson(json: any): ParticipantSearchRequest {
        return new ParticipantSearchRequest({
            EventID: json.EventID ?? null,
            IncludeMerged: json.IncludeMerged,
            Maxitems: json.Maxitems,
            OnlyUsedByMyOrganizer: json.OnlyUsedByMyOrganizer,
            OnlyWithFISCode: json.OnlyWithFISCode,
            OnlyWithNCFLicense: json.OnlyWithNCFLicense,
            Query: json.Query ?? '',
            SearchType:
                json.SearchType == 0
                    ? 'StartsWith'
                    : json.SearchType == 1
                      ? 'EndsWith'
                      : json.SearchType == 2
                        ? 'ExactWord'
                        : json.SearchType == 3
                          ? 'Contains'
                          : json.SearchType == 4
                            ? 'ContainsAll'
                            : 'StartsWith',
        });
    }

    /**
     * Creates an instance of ParticipantSearchRequest from another instance of ParticipantSearchRequest.
     * @param other The ParticipantSearchRequest you want to clone
     * @returns A cloned ParticipantSearchRequest
     */
    public static FromOther(other: ParticipantSearchRequest): ParticipantSearchRequest {
        return ParticipantSearchRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ParticipantSearchRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'ParticipantSearchRequest';
}
